// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type ShrnaPriceCallMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.ShrnaPriceCallInput>;
  productInput?: Types.InputMaybe<Types.SemiConfiguratorProductInput>;
}>;


export type ShrnaPriceCallMutation = { __typename?: 'Mutation', shrnaPriceCall?: { __typename?: 'ShrnaPriceCall', shrnaResult?: Array<{ __typename?: 'ShrnaPriceCallResponse', fullName?: string | null, geneSymbol?: string | null, geneId?: string | null, knockdown?: string | null, species?: string | null, targetSeq?: string | null, method?: string | null, trcVersion?: string | null, oligoSeq?: string | null, validated?: string | null, trcId?: string | null, cellType?: string | null, cloneName?: string | null, synonyms?: Array<string | null> | null, region?: string | null, refSeq?: string | null, searchTrcVersion?: string | null, price?: number | null, currency?: string | null, brand?: string | null, material?: string | null, currencySymbol?: string | null } | null> | null, serverError?: { __typename?: 'ServerError', key?: string | null, value?: string | null } | null } | null };

export type ShrnaPriceCallFragment = { __typename?: 'ShrnaPriceCall', shrnaResult?: Array<{ __typename?: 'ShrnaPriceCallResponse', fullName?: string | null, geneSymbol?: string | null, geneId?: string | null, knockdown?: string | null, species?: string | null, targetSeq?: string | null, method?: string | null, trcVersion?: string | null, oligoSeq?: string | null, validated?: string | null, trcId?: string | null, cellType?: string | null, cloneName?: string | null, synonyms?: Array<string | null> | null, region?: string | null, refSeq?: string | null, searchTrcVersion?: string | null, price?: number | null, currency?: string | null, brand?: string | null, material?: string | null, currencySymbol?: string | null } | null> | null, serverError?: { __typename?: 'ServerError', key?: string | null, value?: string | null } | null };

export type ShrnaAddToCartMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.ShrnaAddToCartInput>;
}>;


export type ShrnaAddToCartMutation = { __typename?: 'Mutation', shrnaAddToCart?: { __typename?: 'ShrnaAddToCartResponse', result?: string | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export const ShrnaPriceCallFragmentDoc = gql`
    fragment ShrnaPriceCall on ShrnaPriceCall {
  shrnaResult {
    fullName
    geneSymbol
    geneId
    knockdown
    species
    targetSeq
    method
    trcVersion
    oligoSeq
    validated
    trcId
    cellType
    cloneName
    synonyms
    region
    refSeq
    searchTrcVersion
    price
    currency
    brand
    material
    currencySymbol
  }
  serverError {
    key
    value
  }
}
    `;
export const ShrnaPriceCallDocument = gql`
    mutation shrnaPriceCall($input: ShrnaPriceCallInput, $productInput: SemiConfiguratorProductInput) {
  shrnaPriceCall(input: $input, productInput: $productInput) {
    ...ShrnaPriceCall
  }
}
    ${ShrnaPriceCallFragmentDoc}`;
export type ShrnaPriceCallMutationFn = ApolloReactCommon.MutationFunction<ShrnaPriceCallMutation, ShrnaPriceCallMutationVariables>;
export type ShrnaPriceCallComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ShrnaPriceCallMutation, ShrnaPriceCallMutationVariables>, 'mutation'>;

    export const ShrnaPriceCallComponent = (props: ShrnaPriceCallComponentProps) => (
      <ApolloReactComponents.Mutation<ShrnaPriceCallMutation, ShrnaPriceCallMutationVariables> mutation={ShrnaPriceCallDocument} {...props} />
    );
    

/**
 * __useShrnaPriceCallMutation__
 *
 * To run a mutation, you first call `useShrnaPriceCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShrnaPriceCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shrnaPriceCallMutation, { data, loading, error }] = useShrnaPriceCallMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useShrnaPriceCallMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShrnaPriceCallMutation, ShrnaPriceCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShrnaPriceCallMutation, ShrnaPriceCallMutationVariables>(ShrnaPriceCallDocument, options);
      }
export type ShrnaPriceCallMutationHookResult = ReturnType<typeof useShrnaPriceCallMutation>;
export type ShrnaPriceCallMutationResult = ApolloReactCommon.MutationResult<ShrnaPriceCallMutation>;
export type ShrnaPriceCallMutationOptions = ApolloReactCommon.BaseMutationOptions<ShrnaPriceCallMutation, ShrnaPriceCallMutationVariables>;
export const ShrnaAddToCartDocument = gql`
    mutation shrnaAddToCart($input: ShrnaAddToCartInput) {
  shrnaAddToCart(input: $input) {
    result
    serverError {
      key
      value
    }
  }
}
    `;
export type ShrnaAddToCartMutationFn = ApolloReactCommon.MutationFunction<ShrnaAddToCartMutation, ShrnaAddToCartMutationVariables>;
export type ShrnaAddToCartComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ShrnaAddToCartMutation, ShrnaAddToCartMutationVariables>, 'mutation'>;

    export const ShrnaAddToCartComponent = (props: ShrnaAddToCartComponentProps) => (
      <ApolloReactComponents.Mutation<ShrnaAddToCartMutation, ShrnaAddToCartMutationVariables> mutation={ShrnaAddToCartDocument} {...props} />
    );
    

/**
 * __useShrnaAddToCartMutation__
 *
 * To run a mutation, you first call `useShrnaAddToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShrnaAddToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shrnaAddToCartMutation, { data, loading, error }] = useShrnaAddToCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShrnaAddToCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShrnaAddToCartMutation, ShrnaAddToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShrnaAddToCartMutation, ShrnaAddToCartMutationVariables>(ShrnaAddToCartDocument, options);
      }
export type ShrnaAddToCartMutationHookResult = ReturnType<typeof useShrnaAddToCartMutation>;
export type ShrnaAddToCartMutationResult = ApolloReactCommon.MutationResult<ShrnaAddToCartMutation>;
export type ShrnaAddToCartMutationOptions = ApolloReactCommon.BaseMutationOptions<ShrnaAddToCartMutation, ShrnaAddToCartMutationVariables>;